/**
 * @fileoverview Agent definition for story-image-prompt-creator-v2.
 *
 * This agent generates rich, artistic prompts for image generation models
 * from a piece of prose, identifying characters and world elements present
 * in the text.
 *
 * @category visuals.prompts.story
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'story-image-prompt-creator-v2',
  kind: 'primitive',
  name: 'Story Image Prompt Creator',
  description: 'Generates a rich, artistic prompt for an image generation model from a piece of prose.',
  category: 'visuals',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'visuals.prompts.story',
    usedBy: [
      'use-writing-editor.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'story-image-creator-fal-v2',
      'multi-reference-visual-prompt-creator-v2',
      'character-image-prompt-creator-v2',
    ],
  },
};
